import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

export default function Profile() {
  const { user, logout, API } = useAuth();
  const navigate              = useNavigate();

  const [showChangePwd, setShowChangePwd] = useState(false);
  const [currentPwd,    setCurrentPwd]    = useState('');
  const [newPwd,        setNewPwd]        = useState('');
  const [confirmPwd,    setConfirmPwd]    = useState('');
  const [message,       setMessage]       = useState('');
  const [msgType,       setMsgType]       = useState('success');
  const [loading,       setLoading]       = useState(false);

  const token = localStorage.getItem('fx_token');

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleChangePassword = async () => {
    setMessage('');

    if (!currentPwd || !newPwd || !confirmPwd) {
      setMessage('Please fill in all fields');
      setMsgType('error');
      return;
    }

    if (newPwd !== confirmPwd) {
      setMessage('New passwords do not match');
      setMsgType('error');
      return;
    }

    if (newPwd.length < 6) {
      setMessage('New password must be at least 6 characters');
      setMsgType('error');
      return;
    }

    setLoading(true);
    try {
      await axios.put(API + '/users/changepassword', {
        currentPassword: currentPwd,
        newPassword:     newPwd,
      }, {
        headers: { Authorization: 'Bearer ' + token }
      });

      setMessage('Password changed successfully!');
      setMsgType('success');
      setCurrentPwd('');
      setNewPwd('');
      setConfirmPwd('');
      setTimeout(() => {
        setShowChangePwd(false);
        setMessage('');
      }, 2000);
    } catch (e) {
      setMessage(e.response?.data || 'Failed to change password');
      setMsgType('error');
    }
    setLoading(false);
  };

  const expiryLabel = () => {
    if (!user?.subscriptionExpiry) return null;
    const days = Math.floor(
      (new Date(user.subscriptionExpiry) - new Date()) /
      (1000 * 60 * 60 * 24));
    if (days < 0)  return { text: 'EXPIRED', color: '#EF4444' };
    if (days === 0) return { text: 'Expires today', color: '#F59E0B' };
    if (days <= 7) return { text: days + ' days left', color: '#F59E0B' };
    return {
      text: new Date(user.subscriptionExpiry)
        .toLocaleDateString('en-IN'),
      color: '#22C55E'
    };
  };

  const expiry = expiryLabel();

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.title}>PROFILE</div>
        <div style={s.sub}>Account details</div>
      </div>

      <div style={s.body}>

        {/* Avatar */}
        <div style={s.avatar}>
          {user?.fullName?.charAt(0)?.toUpperCase() || 'U'}
        </div>
        <div style={s.name}>{user?.fullName}</div>
        <div style={s.role}>
          {user?.isAdmin ? 'Administrator' : 'Client'}
        </div>

        {/* Account Info Card */}
        <div style={s.card}>
          <div style={s.row}>
            <span style={s.key}>Account Type</span>
            <span style={{
              ...s.val,
              color: user?.isAdmin ? '#D97706' : '#3B82F6',
            }}>
              {user?.isAdmin ? 'Admin' : 'Client'}
            </span>
          </div>
          <div style={s.divider} />
          <div style={s.row}>
            <span style={s.key}>Rate Access</span>
            <span style={s.val}>
              {user?.ratePermissions || 'All pairs'}
            </span>
          </div>
          {user?.alertsAccess && (
            <>
              <div style={s.divider} />
              <div style={s.row}>
                <span style={s.key}>Alerts</span>
                <span style={{ ...s.val, color: '#22C55E' }}>
                  Enabled
                </span>
              </div>
            </>
          )}
        </div>

        {/* Subscription Card */}
        {!user?.isAdmin && (
          <div style={s.card}>
            <div style={s.cardTitle}>SUBSCRIPTION</div>
            <div style={s.row}>
              <span style={s.key}>Plan</span>
              <span style={{ ...s.val, color: '#C9A84C', fontWeight: 600 }}>
                {user?.subscriptionPlan || '--'}
              </span>
            </div>
            {expiry && (
              <>
                <div style={s.divider} />
                <div style={s.row}>
                  <span style={s.key}>Expiry</span>
                  <span style={{ ...s.val, color: expiry.color, fontWeight: 600 }}>
                    {expiry.text}
                  </span>
                </div>
              </>
            )}
          </div>
        )}

        {/* Change Password */}
        {!showChangePwd ? (
          <button
            onClick={() => setShowChangePwd(true)}
            style={s.changePwdBtn}>
            Change Password
          </button>
        ) : (
          <div style={s.pwdCard}>
            <div style={s.pwdTitle}>CHANGE PASSWORD</div>

            <input
              type="password"
              style={s.input}
              placeholder="Current password"
              value={currentPwd}
              onChange={e => setCurrentPwd(e.target.value)}
            />
            <input
              type="password"
              style={s.input}
              placeholder="New password"
              value={newPwd}
              onChange={e => setNewPwd(e.target.value)}
            />
            <input
              type="password"
              style={s.input}
              placeholder="Confirm new password"
              value={confirmPwd}
              onChange={e => setConfirmPwd(e.target.value)}
            />

            {message && (
              <div style={{
                ...s.msgBox,
                color: msgType === 'success' ? '#22C55E' : '#EF4444',
                borderColor: msgType === 'success'
                  ? 'rgba(34,197,94,0.3)' : 'rgba(239,68,68,0.3)',
                background: msgType === 'success'
                  ? 'rgba(34,197,94,0.08)' : 'rgba(239,68,68,0.08)',
              }}>
                {message}
              </div>
            )}

            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
              <button
                onClick={() => {
                  setShowChangePwd(false);
                  setMessage('');
                  setCurrentPwd('');
                  setNewPwd('');
                  setConfirmPwd('');
                }}
                style={s.cancelBtn}>
                Cancel
              </button>
              <button
                onClick={handleChangePassword}
                disabled={loading}
                style={{
                  ...s.saveBtn,
                  opacity: loading ? 0.7 : 1,
                }}>
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        )}

        {/* Admin panel button */}
        {user?.isAdmin && (
          <button
            onClick={() => navigate('/admin')}
            style={s.adminBtn}>
            Open Admin Panel
          </button>
        )}

        {/* Logout */}
        <button onClick={handleLogout} style={s.logoutBtn}>
          Logout
        </button>

        <div style={s.version}>FX Capital India  •  v1.0</div>

      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight:     '100vh',
    background:    '#F8FAFC',
    paddingBottom: '80px',
  },
  header: {
    background: '#1B3A6B',
    padding:    '14px 16px',
  },
  title: {
    fontFamily:    'Arial',
    fontSize:      '14px',
    fontWeight:    700,
    color:         '#D4A843',
    letterSpacing: '0.08em',
  },
  sub: {
    fontFamily: 'Arial',
    fontSize:   '10px',
    color:      '#93C5FD',
    marginTop:  '2px',
  },
  body: {
    display:       'flex',
    flexDirection: 'column',
    alignItems:    'center',
    padding:       '32px 20px',
  },
  avatar: {
    width:          '72px',
    height:         '72px',
    background:     '#1B3A6B',
    borderRadius:   '50%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    fontFamily:     'Arial',
    fontSize:       '28px',
    fontWeight:     700,
    color:          '#D4A843',
    marginBottom:   '12px',
  },
  name: {
    fontFamily:   'Arial',
    fontSize:     '18px',
    fontWeight:   500,
    color:        '#111827',
    marginBottom: '4px',
  },
  role: {
    fontFamily:   'Arial',
    fontSize:     '12px',
    color:        '#6B7280',
    marginBottom: '24px',
  },
  card: {
    width:        '100%',
    background:   '#FFFFFF',
    borderRadius: '12px',
    border:       '0.5px solid #E5E7EB',
    padding:      '4px 16px',
    marginBottom: '12px',
  },
  cardTitle: {
    fontFamily:    'Arial',
    fontSize:      '10px',
    fontWeight:    700,
    color:         '#9CA3AF',
    letterSpacing: '0.1em',
    padding:       '10px 0 4px',
  },
  row: {
    display:        'flex',
    justifyContent: 'space-between',
    alignItems:     'center',
    padding:        '12px 0',
  },
  divider: {
    height:     '0.5px',
    background: '#F3F4F6',
  },
  key: {
    fontFamily: 'Arial',
    fontSize:   '13px',
    color:      '#6B7280',
  },
  val: {
    fontFamily: 'Arial',
    fontSize:   '13px',
    fontWeight: 500,
    color:      '#111827',
  },
  changePwdBtn: {
    width:        '100%',
    background:   '#FFFFFF',
    border:       '0.5px solid #E5E7EB',
    borderRadius: '10px',
    padding:      '13px',
    color:        '#1B3A6B',
    fontFamily:   'Arial',
    fontSize:     '14px',
    fontWeight:   500,
    cursor:       'pointer',
    marginBottom: '10px',
  },
  pwdCard: {
    width:        '100%',
    background:   '#FFFFFF',
    borderRadius: '12px',
    border:       '0.5px solid #E5E7EB',
    padding:      '16px',
    marginBottom: '12px',
    display:      'flex',
    flexDirection: 'column',
    gap:          '10px',
  },
  pwdTitle: {
    fontFamily:    'Arial',
    fontSize:      '10px',
    fontWeight:    700,
    color:         '#9CA3AF',
    letterSpacing: '0.1em',
  },
  input: {
    width:        '100%',
    background:   '#F9FAFB',
    border:       '0.5px solid #E5E7EB',
    borderRadius: '8px',
    padding:      '10px 12px',
    color:        '#111827',
    fontSize:     '14px',
    fontFamily:   'Arial',
    outline:      'none',
  },
  msgBox: {
    borderRadius: '6px',
    padding:      '8px 12px',
    fontSize:     '13px',
    fontFamily:   'Arial',
    border:       '1px solid',
  },
  cancelBtn: {
    flex:         1,
    background:   '#F3F4F6',
    border:       'none',
    borderRadius: '8px',
    padding:      '10px',
    color:        '#6B7280',
    fontFamily:   'Arial',
    fontSize:     '13px',
    cursor:       'pointer',
  },
  saveBtn: {
    flex:         2,
    background:   '#1B3A6B',
    border:       'none',
    borderRadius: '8px',
    padding:      '10px',
    color:        '#FFFFFF',
    fontFamily:   'Arial',
    fontSize:     '13px',
    fontWeight:   500,
    cursor:       'pointer',
  },
  adminBtn: {
    width:        '100%',
    background:   '#1B3A6B',
    border:       'none',
    borderRadius: '10px',
    padding:      '13px',
    color:        '#FFFFFF',
    fontFamily:   'Arial',
    fontSize:     '14px',
    fontWeight:   500,
    cursor:       'pointer',
    marginBottom: '10px',
  },
  logoutBtn: {
    width:        '100%',
    background:   '#FFFFFF',
    border:       '0.5px solid #E5E7EB',
    borderRadius: '10px',
    padding:      '13px',
    color:        '#DC2626',
    fontFamily:   'Arial',
    fontSize:     '14px',
    fontWeight:   500,
    cursor:       'pointer',
    marginBottom: '24px',
  },
  version: {
    fontFamily: 'Arial',
    fontSize:   '11px',
    color:      '#9CA3AF',
  },
};